import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, translate, downloadFile, isNullOrEmpty } from '../../../../utils/util';
import * as containerAction from '../../../../actions/containerAction';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Collapsible, Table, Label } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import LabelUI from '../../../../components/UI/LabelUI';
import SelectNew from '../../../../components/UI/SelectNew';
import { ENUMS } from '../../../../utils/constants';

const Monitor = (props) => {
    const [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "calculatedFreeTime", sortOrder: -1 });
    const [filter, setFilter] = useState({});

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        setList(props.list?.items || []);
        // eslint-disable-next-line
    }, [props?.list?.items]);

    const onSearch = (click) => {
        props.getPagedList({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'isEmpty',
                header: 'Estado',
                align: 'left',
                sortable: true,
                body: (rowData) => rowData.isEmpty ? "Vazio" : "Cheio"
            },
            {
                field: 'statusDescription',
                header: 'Status Atual',
                align: 'left',
                sortable: true
            },
            {
                field: 'stayTime',
                header: 'Tempo de Permanência',
                align: 'center',
                body: (rowData) => {
                    return <div>
                        <span>
                            {isNullOrEmpty(rowData.calculatedFreeTime) ? "Sem regra de Freetime cadastrada." : rowData.stayTime}
                        </span>
                    </div>
                },
                sortable: true
            },

            {
                field: 'calculatedFreeTime',
                header: 'FreeTime',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.calculatedFreeTime < 0
                                        ? 'red'
                                        : 'green'
                            }}
                        >
                            {isNullOrEmpty(rowData.calculatedFreeTime) ? "-" : rowData.calculatedFreeTime}
                        </span>
                    </div>

                },
                align: 'center',
                sortable: true
            },
            {
                field: 'calculatedFine',
                header: 'Multa',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    !isNullOrEmpty(rowData.calculatedFine) && rowData.calculatedFine > 0 ? "red" : "green"
                            }}
                        >
                            {isNullOrEmpty(rowData.calculatedFine) ? "-" : `${rowData.currencyFine} ${rowData.calculatedFine}`}
                        </span>
                    </div>

                },
                align: 'center',
                sortable: true
            },
        ];
        return cols;
    };


    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `monitor-${Date.now()}.csv`, "data:text/csv", false);
        })
    }

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Monitor" }} />
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="listHarbor" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s12">
                                            <Input
                                                id="containerOrLot"
                                                name='containerOrLot'
                                                label="Num. Container ou Lote"
                                                type="text"
                                                value={filter?.containerOrLot || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <SelectNew

                                                id="freeTimeStatus"
                                                name='freeTimeStatus'
                                                display="name"
                                                label={"Status"}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={[
                                                    { id: ENUMS.eFreeTimeStatus.OnTime.value, text: ENUMS.eFreeTimeStatus.OnTime.text },
                                                    { id: ENUMS.eFreeTimeStatus.Delayed.value, text: ENUMS.eFreeTimeStatus.Delayed.text },
                                                    { id: ENUMS.eFreeTimeStatus.NoRule.value, text: ENUMS.eFreeTimeStatus.NoRule.text },
                                                ]}
                                                change={onChange}
                                                value={filter?.freeTimeStatus || ''}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <SelectNew

                                                id="isEmpty"
                                                name='isEmpty'
                                                display="name"
                                                label={"Estado"}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={[
                                                    { id: ENUMS.eContainerState.IsEmpty.value, text: ENUMS.eContainerState.IsEmpty.text },
                                                    { id: ENUMS.eContainerState.IsFull.value, text: ENUMS.eContainerState.IsFull.text },

                                                ]}
                                                change={onChange}
                                                value={filter?.isEmpty || ''}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <div id="items" className="container-fluid">
                    <Table
                        totalPages={props.list?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        col={configColumn()}
                        data={list}
                    />
                </div>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        list: state.containerReducer.containers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPagedList: (filter) => {
            dispatch(ContainerService.getPagedMonitor(filter));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportMonitorCsv(filter, callback));
        },

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Monitor));
